import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({

    checkboxContainer: {
        display: 'block',
        position: 'relative',
        paddingRight: '0',
        cursor: 'pointer',
        fontSize: '14px',
        userSelect: 'none',
        left: ' 50%',
        transform: 'translate(-25%, 0)',
   
    },
   

}

));
